module.exports = __webpack_public_path__ + "static/media/puzzle0302.42b13084.png";